import React, { useEffect, useRef } from 'react';
import { Row, Col, Icon, InputNumber, Tooltip, Typography, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import RequiredResolutionsCard from './RequiredResolutionsCard';
import { Card } from 'antd';
import ContentSpecificationAlert from './ContentSpecificationAlert';
import Colors from '../../../../../themes/Colors';

const { Text } = Typography;

const ResolutionSlider = ({
  listResolution,
  groupedDisplays,
  filterByContent,
  hasDifferentResolution,
  resolutionTitle,
  resolutionSubtitle,
  errors,
  toleranceResolution,
  toleranceResolutionInit,
  isSuperUser,
  isPaymentStatusApproved,
  editCampaignActive,
  currentCampaign,
  customContents,
  listResolutionWithContent,
  setListResolutionWithContent,
  removeRelationFromDisplay,
  listOfContentsInCampaign,
  setListOfContentsInCampaign,
  updateImpressionsDisplay,
  removeRelationsOnCampaign,
  showModalDeleteContentRelation,
  showModalContent,
  isTheLastOfTheRelationship,
  setTolerance,
  withCardInRelation,
  fromModal,
  applyTolerance
}) => {
  const { t } = useTranslation();

  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (!editCampaignActive || !isPaymentStatusApproved) return;
    const timer = setTimeout(() => {
      applyTolerance();
    }, 500);
    return () => clearTimeout(timer);
  }, [toleranceResolution]);


  const handleTolerance = value => {
    if (value && value.toString().length > 2) return;
    setTolerance(value);
  };

  return (
    <Row type="flex" align="middle" className="resolutionHeaderRow">
      <Col xs={24} sm={24} md={24} lg={19}>
        <div
          className="ant-collapse-header collapse-resolution"
          style={{ marginTop: '10px', paddingBottom: '10px !important' }}
          role="button"
          tabIndex="0"
          aria-expanded="true"
        >
          <Row type="flex" align="middle" style={{ gap: 8 }}>
            <Col xs={24}>{resolutionTitle}</Col>
            {groupedDisplays && (
              <Col xs={24}>
                <Row
                  className="ant-collapse-subtitle"
                  type="flex"
                  align="middle"
                  style={{ gap: 8 }}
                >
                  {filterByContent ? (
                    <span>{t('To replace this content')}</span>
                  ) : (
                    <>
                      <Icon type="desktop" />
                      <span>{resolutionSubtitle}</span>
                    </>
                  )}
                </Row>
              </Col>
            )}
          </Row>
          {errors && errors['contentsDisplays'] && (
            <p className="error-message error-message-contents-displays">
              {t(errors['contentsDisplays'])}
            </p>
          )}
        </div>
      </Col>

      {!groupedDisplays && (
        <Col xs={24} sm={24} md={24} lg={5} xl={5}>
          <div
            className="contentTolerance"
            role="button"
            tabIndex="0"
            aria-expanded="true"
          >
            <div className="contentToleranceInner">
              <Tooltip placement="left" title={t('Info tolerance')}>
                <Icon
                  className="cardAudienceIconInfo"
                  type="info-circle"
                  theme="outlined"
                  style={{ color: Colors.primaryAccent, fontSize: '16px', alignSelf: 'center' }}
                />
              </Tooltip>
              <p>{t('Tolerance')}:</p>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <InputNumber
                  style={{ width: '70px', minWidth: '70px' }}
                  value={toleranceResolution}
                  formatter={value => `${value}%`}
                  parser={value => value.replace('%', '').slice(0, 2)}
                  onChange={handleTolerance}
                  min={editCampaignActive && isPaymentStatusApproved ? toleranceResolutionInit : 0}
                  max={isSuperUser ? 50 : 25}
                />
                {/* {editCampaignActive && isPaymentStatusApproved && (
                  <Tooltip title={t('Apply tolerance')}>
                    <Button onClick={applyTolerance} type="primary">{t('Apply')}</Button>
                  </Tooltip>
                )} */}
              </div>
            </div>
          </div>
        </Col>
      )}

      {hasDifferentResolution && (
        <>
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={24}
            style={{ marginBottom: '10px' }}
            className="appear-animation"
          >
            <Row type="flex" style={{ gap: '2px', alignItems: 'center' }}>
              {(() => {
                const message = groupedDisplays
                  ? t('resolution.mismatch.single', { tolerance: toleranceResolution })
                  : t(
                      'There are ads that do not adapt correctly to the resolutions. You can continue or select ads from closer resolutions.'
                    );
                return (
                  <>
                    <Icon type="warning" theme="outlined" style={{ color: Colors.atention }} />
                    <Text style={{ color: Colors.textMuted, fontSize: '12px', fontStyle: 'italic' }}>
                      {message}
                    </Text>
                  </>
                );
              })()}
            </Row>
          </Col>
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={24}
            style={{ marginBottom: '15px' }}
            className="appear-animation"
          >
            <Row type="flex" style={{ gap: '10px', alignItems: 'center' }}>
              <ContentSpecificationAlert
                listResolutionWithContent={listResolution || []}
                styleCustom={{ marginBottom: '5px', color: Colors.red }}
                hasText={true}
              />
            </Row>
          </Col>
        </>
      )}

      <Col xs={24} sm={24} md={24} lg={24}>
        <div className="resolution-grid">
          {listResolution &&
            [...listResolution]
              .sort((a, b) => {
                const aAssigned = a.contents && a.contents.length > 0;
                const bAssigned = b.contents && b.contents.length > 0;
                if (aAssigned !== bAssigned) return aAssigned ? 1 : -1;
                const aSize = (a.resolution_width || 0) * (a.resolution_height || 0);
                const bSize = (b.resolution_width || 0) * (b.resolution_height || 0);
                return bSize - aSize;
              })
              .map((relation, index) => (
                <div key={index} style={{ position: 'relative', minHeight: '220px' }}>
                  {relation.contentsDisplays.length > 0 && relation.contents.length ? (
                    <div
                      className="contentRelation"
                      style={{
                        width: `${withCardInRelation + relation.contents.length * 40}px`
                      }}
                    >
                      <Card>
                        {relation.contents.map((content, i) => (
                          <RequiredResolutionsCard
                            key={i}
                            customContents={customContents}
                            removeRelationFromDisplay={removeRelationFromDisplay}
                            setListResolutionWithContent={setListResolutionWithContent}
                            listResolutionWithContent={listResolutionWithContent}
                            loading={false}
                            className="multi"
                            style={{
                              left: `${i * 40}px`,
                              zIndex: relation.contents.length - i
                            }}
                            relation={relation}
                            content={content}
                            showModalDelete={showModalDeleteContentRelation}
                            isWarning={content.differentResolution}
                            removeRelationsOnCampaign={removeRelationsOnCampaign}
                            onClickImage={() => showModalContent(content)}
                            isPaymentStatusApproved={isPaymentStatusApproved}
                            diseabledDeleteButton={
                              groupedDisplays
                                ? isTheLastOfTheRelationship(relation, content)
                                : false
                            }
                            setListOfContentsInCampaign={setListOfContentsInCampaign}
                            listOfContentsInCampaign={listOfContentsInCampaign}
                            updateImpressionsDisplay={updateImpressionsDisplay}
                            groupedDisplays={groupedDisplays}
                            fromModal={fromModal}
                            editCampaignActive={editCampaignActive}
                            currentCampaign={currentCampaign}
                          />
                        ))}
                      </Card>
                    </div>
                  ) : (
                    <RequiredResolutionsCard
                      loading={false}
                      relation={relation}
                      showModalDelete={showModalDeleteContentRelation}
                      removeRelationsOnCampaign={removeRelationsOnCampaign}
                      onClickImage={() => showModalContent(relation)}
                      isPaymentStatusApproved={isPaymentStatusApproved}
                    />
                  )}
                </div>
              ))}
        </div>
      </Col>
    </Row>
  );
};

export default ResolutionSlider;
